<div class="relative">

    <!-- TRIGGER BUTTON (left side of input group) -->
    <button type="button" (click)="toggle()"
        class="flex h-11 w-full items-center justify-between gap-1 rounded-l-lg border border-r-0 bg-gray-50 px-3 text-sm shadow-theme-xs transition-colors focus:outline-none focus:ring-3 dark:bg-gray-800"
        [ngClass]="disabled
            ? 'cursor-default border-gray-200 text-gray-400 opacity-70 dark:border-gray-700 dark:text-gray-500'
            : 'cursor-pointer border-gray-300 text-gray-700 hover:bg-gray-100 focus:border-brand-300 focus:ring-brand-500/10 dark:border-gray-700 dark:text-white/80 dark:hover:bg-gray-700 dark:focus:border-brand-800'"
        [disabled]="disabled">
        <span class="whitespace-nowrap font-medium">{{ selectedLabel }}</span>
        <svg viewBox="0 0 20 20" fill="currentColor"
            class="h-3.5 w-3.5 shrink-0 text-gray-400 transition-transform duration-150"
            [ngClass]="isOpen ? 'rotate-180' : ''">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
        </svg>
    </button>

    <!-- DROPDOWN PANEL -->
    @if (isOpen) {
    <div
        class="absolute left-0 z-50 mt-1 min-w-65 rounded-xl border border-gray-200 bg-white shadow-xl dark:border-gray-700 dark:bg-gray-900">

        <!-- SEARCH INPUT -->
        <div class="border-b border-gray-100 p-2 dark:border-gray-700">
            <div class="relative">
                <div class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <svg class="h-4 w-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                </div>
                <input type="text" [(ngModel)]="searchTerm" (input)="onSearch()"
                    placeholder="Buscar país o código..."
                    autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
                    class="w-full rounded-lg border border-gray-200 bg-gray-50 py-2 pl-9 pr-3 text-sm text-gray-800 placeholder:text-gray-400 focus:border-brand-300 focus:outline-none focus:ring-2 focus:ring-brand-500/10 dark:border-gray-600 dark:bg-gray-800 dark:text-white dark:placeholder:text-gray-500"
                    autofocus />
            </div>
        </div>

        <!-- RESULTS LIST -->
        <div class="max-h-56 overflow-y-auto">
            @if (filtered.length === 0) {
            <div class="py-8 text-center text-sm text-gray-400">Sin resultados</div>
            } @else {
            @for (c of filtered; track c.iso2) {
            <button type="button" (click)="select(c)"
                class="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm transition-colors hover:bg-gray-50 dark:hover:bg-gray-800"
                [ngClass]="c.phoneCode === value ? 'bg-brand-50 dark:bg-brand-900/20' : ''">
                <span class="w-12 shrink-0 font-mono text-xs text-gray-400">(+{{ c.phoneCode }})</span>
                <span class="truncate text-gray-700 dark:text-gray-300">{{ c.nameES }}</span>
                @if (c.phoneCode === value) {
                <svg class="ml-auto h-4 w-4 shrink-0 text-brand-500" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                }
            </button>
            }
            }
        </div>

    </div>
    }

</div>
